import { Box, Typography } from "@mui/material"
import { styled } from "@mui/system"
import SessionSpeakerCard from "components/sessions/SessionSpeakerCard"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import React from "react"

interface SessionSpeakersProps {
  className?: string
  session: ConventionSession
}

const SessionSpeakers = (props: SessionSpeakersProps) => {
  const { session, className } = props

  return (
    <_Container className={className}>
      <_Title component="h5">Speakers</_Title>
      <_List>
        {session.assignments?.map((assignment) => {
          if (!assignment.admin_user) return null
          return (
            <_ListItem key={assignment.id}>
              <SessionSpeakerCard adminUser={assignment.admin_user} />
            </_ListItem>
          )
        })}
      </_List>
    </_Container>
  )
}

export default SessionSpeakers

const _Container = styled(Box)({}) as typeof Box
const _Title = styled(Typography)(({ theme }) => ({
  ...theme.fonts.lato400,
  fontSize: "20px",
  lineHeight: "14px",
  margin: 0,
})) as typeof Typography

const _List = styled("ul")({
  display: "flex",
  flexFlow: "column nowrap",
  alignItems: "stretch",
  justifyContent: "stretch",
  gap: "25px",
  marginTop: "30px",
  padding: 0,
  listStyleType: "none",
})

const _ListItem = styled("li")({})
